import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#E8E4DC] bg-[#FAFAF9] mt-auto" data-testid="footer">
      <div className="px-6 sm:px-12 py-6 max-w-[1200px] mx-auto">
        {/* Disclaimer banner */}
        <p className="text-[10px] sm:text-xs text-red-500/80 font-medium mb-5 tracking-wide">
          Unauthorized scraping, reproduction, or commercial use of data from this platform is strictly prohibited.
        </p>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Activity className="w-4 h-4 text-[#B48C36]" />
            <span className="font-heading text-sm font-bold text-[#78716C]">
              Bullion<span className="text-[#B48C36]">Track</span>
            </span>
          </div>
          <div className="flex flex-wrap gap-4 text-[10px] sm:text-xs text-[#A8A29E]">
            <Link to="/disclaimer" className="hover:text-[#1C1917] transition-colors" data-testid="footer-disclaimer-link">
              Disclaimer
            </Link>
            <Link to="/terms" className="hover:text-[#1C1917] transition-colors" data-testid="footer-terms-link">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-[#1C1917] transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <a href="mailto:Bulliontrack995@gmail.com" className="hover:text-[#1C1917] transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
